import React from "react";
import { Controller } from "react-hook-form";

import { cn } from "../../utils/utils";

const CountryList = (props) => {
  const { control, name, label, type, onchange, errors, placeholder, className, options } = props;

  return (
    <div className={cn(" col-span-2 md:col-span-1 flex flex-col gap-2 relative", className)}>
      <label htmlFor=""> {label}</label>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, onBlur, value, disabled } }) => (
          <>
            <select
              disabled={disabled}
              value={value}
              name={name}
              type={type}
              onChange={(country) => onChange(country)}
              placeholder={placeholder}
              onWheel={(e) => e.target.blur()}
              className="h-[52px] px-4  outline-none rounded-v-md  w-full border border-neutral-30 appearance-none disabled:bg-neutral-10"
            >
              <option value="" hidden>
                {" "}
                انتخاب کنید ...
              </option>
              {options.map((option, index) => {
                return (
                  <option
                    key={index}
                    className="p-2 flex justify-between w-full "
                    value={option.country_data.id}
                  >
                    {/* return   <option key={index} className="p-2 flex justify-between w-full " value={ option.country_data.id} > */}
                    {option.country_data.persian_country_name} &nbsp;
                    {`(${option.country_data.code})`}
                  </option>
                );
              })}
            </select>
            <div className="pointer-events-none absolute top-1/2 translate-y-[50%] left-0 flex items-center px-2 text-gray-700 ">
              <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
              </svg>
            </div>
          </>
        )}
      />
      {errors?.message && <span className="text-red-500 text-sm">{errors?.message}</span>}
    </div>
  );
};

export default CountryList;
